<mat-toolbar class="background-color-green" style=" position: sticky; top: 0; z-index: 7;">
    <a [routerLink]="" (click)="backClicked()">
        <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="arrow_back" style="padding-top:9px; margin-right:10px; color:white;"></mat-icon>
    </a>
    <span class="text-color-white">{{ 'ml_143978' | translate }}</span>
    <span class="text-color-white" style="margin-left: 6px;" *ngIf="browserLangToUse.includes('zh')"> ( {{ apexId }} )</span>
    <span class="example-spacer"></span>    
    <mat-select hideSingleSelectionIndicator class="select-custom" [(value)]="selectedYear" (selectionChange)="setAllOrYearFromSelect($event.value)" >
        @for (year of yearArray; track year) {
            <mat-option style="font-size: 12px;" [value]="year.textValue">{{year.textString}}</mat-option>
        }
    </mat-select>     
</mat-toolbar>

<div *ngIf="isLoading" class="center">
    <mat-spinner class="example-margin" [color]="color"></mat-spinner>
</div>

<div *ngIf="!isLoading">
    <mat-list>    
        
        @if(coachingMaster.data.length === 0){
            <span class="text-color-blue" style="font-size: 20px; margin-left: 10px;">{{ 'ml_151232' | translate }}</span>
        }
        @else {
            
            @for (coaching of coachingToShow; track coaching) {                
                <mat-card class="example-card mat-card-background-color-white-smoke">
                    <mat-card-header style="padding-bottom: 4px; padding-top: 4px;">
                        <mat-card-subtitle class="text-color-green">{{ formatDate( coaching.coachingTime ) }}</mat-card-subtitle>
                        <mat-card-title style="font-size: 14px; line-height: 20px; color: gray;">
                            <span style="font-weight: 1000;">{{ 'ml_144059' | translate }}: </span>
                            <span >{{coaching.title}}</span>
                            
                        </mat-card-title>
                        
                    </mat-card-header>
                    <!-- <mat-divider style="margin-top: 10px; margin-bottom: 10px;" *ngIf="coaching.coachingResult"></mat-divider> -->
                    <!-- <mat-card-content *ngIf="coaching.coachingResult">
                        <span style="font-weight: 1000; color: gray;">                            
                            {{ 'ml_151201' | translate }}: 
                        </span>
                        <span style="color: gray;">{{ coaching.coachingResult }}</span>
                    </mat-card-content> -->
                    <mat-card-actions *ngIf="coaching.attachmentVisibletoDriver">                                                
                        <button mat-raised-button style="background-color: #00BFFF; color: white;" (click)="openDialog(coaching)" class="text-color-blue">{{ 'ml_144011' | translate }}</button>                                              
                    </mat-card-actions>
                </mat-card>
            }
        }
        
    </mat-list>
</div>
